import { useAppDispatch } from "@/core/app/hooks"
import {
  LabelStagingType,
  SelectSideType,
  SelectToothType,
} from "@/core/app/slices/user/user.type"
import { Box } from "@mui/material"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormLabel from "@mui/material/FormLabel"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
export const StageNumber = ({
  currPrint,
  updateModel,
}) => {
  const { t } = useTranslation("common")
  const dispatch = useAppDispatch()

  // checkbox if No stage
  const [stagingNumber, setStagingNumber] = useState<LabelStagingType>(
    LabelStagingType.Yes,
  )
  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as LabelStagingType
    setStagingNumber(value)
    dispatch(updateModel({ LabelStagingNumber: value }))
  }

  // tooth number
  const [toothNumber, setToothNumber] = useState<string>("")
  const handleToothNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as SelectToothType
    setToothNumber(value)
    dispatch(updateModel({ SelectToothNumber: value }))
  }

  // side number
  const [sideNumber, setSideNumber] = useState<string>("")
  const handleSideNumber = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as SelectSideType
    setSideNumber(value)
    dispatch(updateModel({ SelectSideNumber: value }))
  }

  useEffect(() => {
    if (currPrint?.LabelStagingNumber) {
      setStagingNumber(currPrint?.LabelStagingNumber)
    }
    if (currPrint?.SelectToothNumber) {
      setToothNumber(currPrint?.SelectToothNumber)
    }
    if (currPrint?.SelectSideNumber) {
      setSideNumber(currPrint?.SelectSideNumber)
    }
  }, [
    currPrint?.LabelStagingNumber,
    currPrint?.SelectToothNumber,
    currPrint?.SelectSideNumber,
  ])
  return (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column" }}
      gap={3}
    >
      <FormControl>
        <FormLabel id="stageNumber">
          {t(`stlPrinting.stageNumberlabel`)}
        </FormLabel>
        <RadioGroup
          row
          sx={{ marginLeft: "10px", gap: "40px" }}
          aria-labelledby="stageNumber"
          name="radio-buttons-group"
          value={stagingNumber}
          onChange={handleCheck}
        >
          <FormControlLabel
            value={LabelStagingType.Yes}
            control={<Radio />}
            label={t(`stlPrinting.optionYes`)}
          />
          <FormControlLabel
            value={LabelStagingType.No}
            control={<Radio />}
            label={t(`stlPrinting.optionNo`)}
          />
        </RadioGroup>
      </FormControl>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          gap: "10px",
        }}
      >
        <Box sx={{ marginRight: "10px", flex: 1 }}>
          <FormControl>
            <FormLabel id="toothNumber">
              {t(`stlPrinting.selectTheTooth`)}
            </FormLabel>
            <RadioGroup
              sx={{ marginLeft: "10px" }}
              aria-labelledby="toothNumber"
              name="radio-buttons-group"
              value={toothNumber}
              onChange={handleToothNumber}
            >
              <FormControlLabel
                value={SelectToothType.SecondPremolarLeft}
                control={<Radio />}
                label={t(`stlPrinting.stageNumberoption1`)}
              />
              <FormControlLabel
                value={SelectToothType.FirstMolarLeft}
                control={<Radio />}
                label={t(`stlPrinting.stageNumberoption2`)}
              />
              <FormControlLabel
                value={SelectToothType.SecondPremolarRight}
                control={<Radio />}
                label={t(`stlPrinting.stageNumberoption3`)}
              />
              <FormControlLabel
                value={SelectToothType.FirstMolarRight}
                control={<Radio />}
                label={t(`stlPrinting.stageNumberoption4`)}
              />
            </RadioGroup>
          </FormControl>
        </Box>
        <Box sx={{ flex: 1 }}>
          <FormControl>
            <FormLabel id="sideNumber">
              {t(`stlPrinting.selectTheSide`)}
            </FormLabel>
            <RadioGroup
              sx={{ marginLeft: "10px" }}
              aria-labelledby="sideNumber"
              name="radio-buttons-group"
              value={sideNumber}
              onChange={handleSideNumber}
            >
              <FormControlLabel
                value={SelectSideType.Buccal}
                control={<Radio />}
                label={t(`stlPrinting.stageNumbersideoption1`)}
              />
              <FormControlLabel
                value={SelectSideType.Lingual}
                control={<Radio />}
                label={t(`stlPrinting.stageNumbersideoption2`)}
              />
            </RadioGroup>
          </FormControl>
        </Box>
      </Box>
    </Box>
  )
}
